<div class="tr flex layout-row layout-align-start-center"
     [ngClass]="{'highlighted': highlighted}">
  <!--Checkbox-->
  <div class="flex td medium sticky layout-row layout-align-start-center"
       [ngStyle]="{'border-left': '7px solid ' + route.color}">

    <!--Actions-->
    <div class="layout-row layout-align-start-center">
      <app-route-action-menu [route]="route"
                             (onAssign)="onAssignRoute.emit(route)"
                             (onAssignAndSelect)="onAssignRouteAndSelectDriver.emit(route)"
                             (onHandleUnpacked)="onHandleUnpackedDeliveries.emit(route)"
                             (onReoptimize)="onReoptimizeRoute.emit(route.id)"
                             (onBlock)="onBlockRoute.emit(route.id)"
                             (onUnblock)="onUnBlockRoute.emit(route.id)"
                             (onReset)="onResetRoute.emit(route)"
                             (onUpdateBranches)="onUpdateBranches.emit(route)"
                             (onUpdateResource)="onUpdateResource.emit(route)"
                             (onUpdateLogisticsVehicle)="onUpdateLogisticsVehicle.emit({task: $event, route: route})"
                             (onManageAssistants)="onManageAssistants.emit(route)"
                             (onChangeRouteColor)="onChangeRouteColor.emit(route)"
                             (onRemove)="onDeleteRoute.emit(route)"
                             (onPrintIkea)="onPrintIkea.emit(route)"
                             (onPrint)="onPrint.emit(route.id)"
                             (onDownloadBillOfLading)="onDownloadBillOfLading.emit(route.id)"
                             (onPrintBillOfLading)="onPrintBillOfLading.emit(route.id)"
                             (onPrintLoadingSheet)="onPrintLoadingSheet.emit(route.id)"
                             (onExport)="onExport.emit(route.id)">

      </app-route-action-menu>
    </div>

    <div class="layout-column">
      <div class="layout-row layout-align-start-center">
        <!--Visibility-->
        <bringoz-button type="tertiary"
                        appBringozIdGenerator="viewRouteOnMapAndTimeline"
                        class="visibility-button margin-right-5"
                        [ngbTooltip]="'View/Hide Map View' | translate"
                        openDelay="300" triggers="hover"
                        (onClick)="onToggleShowRoute.emit(route);$event.stopPropagation();">
          <bringoz-icon iconName="show" [fill]="show ? '#266aff' : '#7e7e7e'"></bringoz-icon>
        </bringoz-button>

        <div class="layout-row layout-align-start-center">
          <app-bringoz-status-tag [status]="route.status" [isSmall]="true"></app-bringoz-status-tag>

          <!--Block-->
          <bringoz-icon *ngIf="route.isBlockedByUser || route.lockActionsInfo?.actionsLocked"
                        class="margin-left-5"
                        [ngbTooltip]="route.lockActionsInfo?.actionsLocked ? ('Locked Autonomous Route' | translate): ('Locked' | translate)"
                        openDelay="300"
                        triggers="hover"
                        iconName="lock-outline"
                        fill="#7e7e7e">
          </bringoz-icon>

        </div>
      </div>

      <div class="layout-row layout-align-start-center">
        <app-bringoz-checkbox [isChecked]="isSelected"
                              (clickEvent)="onToggle.emit(route);$event.stopPropagation();">

        </app-bringoz-checkbox>

        <div class="layout-row layout-align-start-center margin-left-5"
             (mouseenter)="canCopyRouteId = true"
             (mouseleave)="canCopyRouteId = false">
          <app-bringoz-state-link class="flex text-ellipsis"
                                  [state]="'planning-route'"
                                  [params]="{id: route.id}"
                                  [permission]="'routes.list'"
                                  [text]="route.id">
          </app-bringoz-state-link>

          <app-text-copy-button *ngIf="canCopyRouteId" [text]="route.id" [isShowCopyBtn]="true"></app-text-copy-button>
        </div>
      </div>
    </div>
  </div>

  <!--Scheduled-->
  <div *ngIf="columns.scheduled?.enabled" class="td layout-row flex flex-gt-xs-10 small wrap-text">
    <span class="br-body-2">{{route | timeWindow }}</span>
  </div>

  <!--Resource-->
  <div *ngIf="columns.resource?.enabled" class="td layout-column flex flex-gt-xs-10 small text-ellipsis">
    <span class="hide-gt-xs br-caption-2">{{'Resource' | translate}}</span>
    <div class="layout-row layout-align-start-center">
      <span class="br-body-1 font-weight-400">{{route.supplyResourceName}}</span>
      <app-skill-tags class="margin-left-5" [skillsIds]="route.requiredSkills"></app-skill-tags>
    </div>

    <app-bringoz-state-link *ngIf="route.agentReference"
                            class="margin-bottom-5"
                            [ngbTooltip]="route.agentReference | userName"
                            openDelay="300" triggers="hover"
                            [state]="'agent.agent-profile'"
                            [permission]="'drivers.get'"
                            [params]="{id: route.agentReference.id}"
                            [text]="route.agentReference | userName">
    </app-bringoz-state-link>

    <app-bringoz-state-link *ngIf="route.planningResource?.mainLogisticsVehicleReference"
                            class="flex text-ellipsis margin-bottom-5"
                            [state]="'logistics-vehicle.vehicle-profile'"
                            [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.name"
                            openDelay="300" triggers="hover"
                            [params]="{id: route.planningResource.mainLogisticsVehicleReference.id}"
                            [text]="route.planningResource.mainLogisticsVehicleReference.name">
    </app-bringoz-state-link>

    <ng-container *ngIf="!!route.planningResource?.attachedLogisticsVehicleReferences?.length">
      <app-bringoz-state-link
              *ngFor="let attachedVehicle of route.planningResource.attachedLogisticsVehicleReferences"
              [state]="'logistics-vehicle.vehicle-profile'"
              [ngbTooltip]="attachedVehicle.name"
              openDelay="300" triggers="hover"
              [params]="{id: attachedVehicle.id}"
              [text]="attachedVehicle.name">
      </app-bringoz-state-link>
    </ng-container>


  </div>

  <!--Vehicle plate number-->
  <div *ngIf="columns.vehiclePlateNumber?.enabled" layout="column"
       class="layout-column flex flex-gt-xs-10 td small text-ellipsis">
      <span *ngIf="!!route.planningResource?.mainLogisticsVehicleReference?.licensePlateNumber"
            [ngbTooltip]="route.planningResource.mainLogisticsVehicleReference.licensePlateNumber"
            openDelay="300" triggers="hover">
        {{route.planningResource.mainLogisticsVehicleReference.licensePlateNumber}}
      </span>
  </div>

  <!--Assistants-->
  <div *ngIf="columns.assistants?.enabled" class="flex layout-column td small">

    <app-bringoz-items-link-list [state]="'agent.agent-profile'"
                                 [items]="route.assistantAgentReferences"
                                 maxDisplay="2"
                                 [permission]="'drivers.get'">

    </app-bringoz-items-link-list>

  </div>

  <!--Deliveries-->
  <div *ngIf="columns.deliveries?.enabled" class="td flex layout-column layout-align-center-start xxsmall">
    <ng-container *ngIf="route.serviceIdList?.length">
      <span class="br-caption-2 hide-gt-xs" translate>Services</span>
      <span class="br-body-2">{{route.serviceIdList.length}}</span>
    </ng-container>
  </div>

  <!--Accounts-->
  <div *ngIf="columns.accounts?.enabled" class="td flex layout-column layout-align-center-start small">
    <ng-container *ngIf="!!route.accountIds?.length">
      <span class="br-caption-2 hide-gt-xs" translate>Accounts</span>
      <span class="br-body-2">{{route.accountIds.length}}</span>
    </ng-container>
  </div>

  <!--Totals-->
  <div *ngIf="columns.totals?.enabled && hasFleetManagementPermission"
       class="td small text-center flex layout-column text-ellipsis">


    <app-route-totals class="flex"
                      [weight]="route.maxLoad?.weightLoad"
                      [volume]="route.maxLoad?.calculatedVolume"
                      [numberOfPackages]="route.maxLoad?.numberOfItemsLoad"
                      [numberOfSpots]="route.totalLoad?.numberOfSpots"
                      [numberOfPallets]="route.totalLoad?.numberOfPallets"
                      [subVolumeList]="route.totalLoad?.subVolume">

    </app-route-totals>

  </div>

  <!--Capacity Risks-->
  <div *ngIf="columns.capacityRisks?.enabled && hasFleetManagementPermission"
       class="td small flex layout-column text-center text-ellipsis">

    <app-bringoz-capacity showPackages="true"
                          [weight]="route.maxLoad?.weightLoad"
                          [volume]="route.maxLoad?.calculatedVolume"
                          [packages]="route.maxLoad?.numberOfItemsLoad"
                          [pallets]="route.maxLoad?.numberOfPalletsLoad"
                          [totalWeight]="route.maxLoad?.weight"
                          [totalVolume]="route.maxLoad?.dimensions?.cube"
                          [totalPackages]="route.maxLoad?.numberOfItems"
                          [totalPallets]="route.maxLoad?.numberOfPallets">

    </app-bringoz-capacity>

  </div>

  <!--Cost-->
  <div *ngIf="columns.cost?.enabled" class="td flex layout-xs-column flex-gt-xs-5 small">
    <ng-container *ngIf="route.courierPrice !== undefined">
      <span class="br-caption-2 hide-gt-xs" translate>Cost</span>
      <span class="br-body-2">{{route.courierPrice | bringozPrice}}</span>
    </ng-container>
  </div>

  <!--Length-->
  <div *ngIf="columns.distance?.enabled" class="td flex layout-xs-column flex-gt-xs-5 small">
    <ng-container *ngIf="route.totalDistanceMeter !== undefined">
      <span class="br-caption-2 hide-gt-xs" translate>Length</span>
      <span class="br-body-2">{{route.totalDistanceMeter | bringozDistance: '---' : true}}</span>
    </ng-container>
  </div>

  <!--Warn-->
  <div *ngIf="columns.alerts?.enabled"
       class="td flex layout-column layout-align-center-start flex-gt-xs-5 small text-center"
       [ngClass]="{'warn': route.stats?.notPacked > 0}">
      <span class="br-body-2"
            [ngbTooltip]="'Unpacked Delivery' | translate"
            openDelay="300" triggers="hover">
        {{route.stats?.notPacked > 0 ? route.stats.notPacked : '---'}}
      </span>
  </div>

  <!--Progress-->
  <div *ngIf="columns.progress?.enabled"
       class="td hide show-gt-xs flex-gt-xs layout-row layout-align-start-center small">

    <app-bringoz-capacity-bar class="flex"
                              [value]="(route.stats?.finished * 100) / route.stats?.total"
                              [isDisableSeverity]="true">

    </app-bringoz-capacity-bar>
    <span
            class="br-caption-1 font-weight-500 margin-left-5">{{((route.stats.finished * 100) / route.stats.total) | number}}
      %</span>
  </div>

  <!--Total Time-->
  <div *ngIf="columns.totalTime?.enabled" class="td flex layout-xs-column flex-gt-xs-10 small text-ellipsis">
    <ng-container *ngIf="route.totalTimeSec !== undefined">
      <span class="br-caption-2 hide-gt-xs" translate>Total Time</span>
      <span class="br-body-2">{{route.totalTimeSec | bringozTimeConvert}}</span>
    </ng-container>
  </div>

  <!--Agent operational Units-->
  <div *ngIf="columns.agentOperationalUnits?.enabled" class="td small text-center text-ellipsis margin-right-15 flex">
    <branches-indicator *ngIf="!!route.agentBranchIds?.length"
                        [branches]="route.agentBranchReferences">
    </branches-indicator>
  </div>

  <!--Service Area-->
  <div *ngIf="columns.serviceAreas?.enabled"
       class="td small text-center text-ellipsis margin-right-15 flex layout-column">
    <span class="br-caption-2 hide-gt-xs" translate>Service Area</span>

    <ng-container *ngIf="route.serviceAreaIdList?.length <= 2">
        <span class="br-body-2" *ngFor="let areaId of route.serviceAreaIdList">
          {{ serviceAreasMap[areaId]}}
        </span>
    </ng-container>

    <ng-container *ngIf="route.serviceAreaIdList?.length > 2">
        <span class="br-body-2"
              [ngbTooltip]="serviceAreaTooltipTmpl" openDelay="300" triggers="hover">
          {{route.serviceAreaIdList.length}}
        </span>

      <ng-template #serviceAreaTooltipTmpl>
        <div class="layout-column">
          <p class="br-body-2" *ngFor="let areaId of route.serviceAreaIdList">
            {{serviceAreasMap[areaId]}}
          </p>
        </div>
      </ng-template>

    </ng-container>

  </div>

  <!--Dynamic Columns-->
  <div class="td flex layout-row small text-ellipsis"
       *ngFor="let metaData of dynamicColumns">
    <span class="br-body-2 text-ellipsis">{{route.metaData | bringozMetaDataDisplay: metaData}}</span>
  </div>

</div>
